import { Component, OnInit, ViewChild } from '@angular/core';

import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators, FormGroup } from '@angular/forms';
import { ThrowStmt } from '@angular/compiler';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { StaticPageContentService } from './static-page-content.service';
import { NgModule } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'app-static-page-content',
  templateUrl: './static-page-content.component.html',
  styleUrls: ['./static-page-content.component.css']
})

export class StaticPageContentComponent implements OnInit {
  staticPageForm: DVFormGroup;
  aboutUs: DVFormGroup;
  aboutUsSeo: DVFormGroup;
  contactUs: DVFormGroup;
  contactUsSeo: DVFormGroup;
  privacy: DVFormGroup;
  privacySeo: DVFormGroup;
  termsConditions: DVFormGroup;
  termsConditionsSeo: DVFormGroup;
  faqs: DVFormGroup;
  faqsSeo: DVFormGroup;
  @ViewChild('editor', {
    static: true
  })
  editor: QuillEditorComponent;
  constructor(
    private staticPageApi: StaticPageContentService,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.staticPageForm = new DVFormGroup({
      aboutUs: new DVFormGroup({
        content: new DVFormControl(),
        seo: new DVFormGroup({
          name: new DVFormControl(),
          description: new DVFormControl(),
          keywords: new DVFormControl()
        })
      }),
      contactUs: new DVFormGroup({
        email: new DVFormControl(null, {
          'Email is not in a valid format': Validators.email
        }),
        phone: new DVFormControl(),
        content: new DVFormControl(),
        seo: new DVFormGroup({
          name: new DVFormControl(),
          description: new DVFormControl(),
          keywords: new DVFormControl()
        })
      }),
      privacy: new DVFormGroup({
        // email: new DVFormControl(null, {
        //   'Email is required': Validators.required,
        //   'Email is not in a valid format': Validators.email
        // }),
        // phone: new DVFormControl(null, {
        //   'phone is required': Validators.required
        // }),
        content: new DVFormControl(),
        seo: new DVFormGroup({
          name: new DVFormControl(),
          description: new DVFormControl(),
          keywords: new DVFormControl()
        })
      }),
      termsConditions: new DVFormGroup({
        content: new DVFormControl(),
        seo: new DVFormGroup({
          name: new DVFormControl(),
          description: new DVFormControl(),
          keywords: new DVFormControl()
        })
      }),
      faq: new DVFormGroup({
        seo: new DVFormGroup({
          name: new DVFormControl(),
          description: new DVFormControl(),
          keywords: new DVFormControl()
        })
      })
    });
    this.aboutUs = this.staticPageForm.controls[`aboutUs`] as DVFormGroup;
    this.aboutUsSeo = this.aboutUs.controls[`seo`] as DVFormGroup;
    this.contactUs = this.staticPageForm.controls[`contactUs`] as DVFormGroup;
    this.contactUsSeo = this.contactUs.controls[`seo`] as DVFormGroup;
    this.privacy = this.staticPageForm.controls[`privacy`] as DVFormGroup;
    this.privacySeo = this.privacy.controls[`seo`] as DVFormGroup;
    this.termsConditions = this.staticPageForm.controls[
      `termsConditions`
    ] as DVFormGroup;
    this.termsConditionsSeo = this.termsConditions.controls[`seo`] as DVFormGroup;
    this.faqs = this.staticPageForm.controls[`faq`] as DVFormGroup;
    this.faqsSeo = this.faqs.controls[`seo`] as DVFormGroup;
  }

  ngOnInit() {
    this.staticPageApi.getAllStaticPage().subscribe(Response => {
      // console.log(Response)
      this.mapData(Response);
    });
  }
  mapData(Response) {
    delete Response.data.staticContent.aboutUs.gallery;
    this.staticPageForm.controls[`aboutUs`].setValue(
      Response.data.staticContent.aboutUs
    );
    this.staticPageForm.controls[`contactUs`].setValue(
      Response.data.staticContent.contactUs
    );
    this.staticPageForm.controls[`privacy`].setValue(
      Response.data.staticContent.privacy
    );
    this.staticPageForm.controls[`termsConditions`].setValue(
      Response.data.staticContent.termsConditions
    );
    this.staticPageForm.controls[`faq`].setValue(
      Response.data.staticContent.faq
    );
  }
  submitForm() {
    if (this.staticPageForm.valid) {
      this.staticPageApi.editStaticPage(this.staticPageForm.value).subscribe(
        Response => {
          // console.log(Response)
          this.notifier.success('Static Page Contet Updated Successfully');
          this.router.navigateByUrl('/dashboard');
        },
        err => {
          this.notifier.error(err.error.userMessage);
        }
      );
    } else {
      this.staticPageForm.forceShowErrors();
    }
  }
}
